const PREFIX = 'gx-webmail-static-';
const EVENT = 'gx-webmail-privacy-expired';
const CHANNEL = 'gx-webmail-privacy';
let broadcast: BroadcastChannel | undefined;

function channel() {
  if (!broadcast && typeof BroadcastChannel !== 'undefined') {
    broadcast = new BroadcastChannel(CHANNEL);
    broadcast.onmessage = event => {
      if (event.data === 'expired') { void clearStaticCaches(); window.dispatchEvent(new Event(EVENT)); }
    };
  }
  return broadcast;
}

/** Clear static caches on logout or MFA/session expiry, including an installing/waiting worker. */
export async function clearStaticCaches() {
  try {
    navigator.serviceWorker?.controller?.postMessage({ type: 'CLEAR_STATIC_CACHES' });
    const registration = await navigator.serviceWorker?.getRegistration(import.meta.env.BASE_URL);
    registration?.active?.postMessage({ type: 'CLEAR_STATIC_CACHES' });
    registration?.installing?.postMessage({ type: 'CLEAR_STATIC_CACHES' });
    registration?.waiting?.postMessage({ type: 'CLEAR_STATIC_CACHES' });
    if ('caches' in window) for (const key of await caches.keys()) if (key.startsWith(PREFIX)) await caches.delete(key);
  } catch { /* Private browsing can disable Cache Storage. Private responses are never cached. */ }
}

export function expirePwa() {
  channel()?.postMessage('expired');
  return clearStaticCaches();
}
export function onPeerExpiry(listener: () => void) {
  channel(); window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
export function registerPwa() {
  if (import.meta.env.PROD && 'serviceWorker' in navigator) void navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`, { scope: import.meta.env.BASE_URL, updateViaCache: 'none' }).catch(() => undefined);
  window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
}

const OWNED = 'gx-webmail-owned-session';
/** Remember that this browser held an authenticated session of ours (no identity or token is stored). */
export function markOwnedSession(owned: boolean) {
  try { if (owned) localStorage.setItem(OWNED, '1'); else localStorage.removeItem(OWNED); } catch { /* storage disabled */ }
}
/** Purge only after an owned session ended; a first load without any session must leave the precache alone. */
export async function expireOwnedSession() {
  let owned = false;
  try { owned = localStorage.getItem(OWNED) === '1'; } catch { /* storage disabled */ }
  if (!owned) return;
  markOwnedSession(false);
  await expirePwa();
}
